// src/stockx/directional/ArrowRightIcon.ts
import { createIcon } from "@chakra-ui/icons";
var ArrowRightIcon = createIcon({
  displayName: "ArrowRightIcon",
  viewBox: "0 0 50 50",
  d: "M24.7 42.0999L43 24.9999L24.7 7.8999L22.2 10.5999L35.5 23.0999L7 23.0999L7 26.8999L35.5 26.8999L22.2 39.3999L24.7 42.0999Z"
});
var ArrowRightIcon_default = ArrowRightIcon;

export {
  ArrowRightIcon_default
};
